// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"437":"cccb2c3e","506":"43149adc","632":"8cceaca9"}[chunkId] + ".chunk.css";
};